<template>
  <div class="onlytitle" :class="{ 'fixed': pic.fixed }"
  :style="{ backgroundImage: 'url(' + background.url + ')' }">
    <div class="txt">
      <slot name="title"></slot>
      <slot name="subtitle"></slot>
      <slot name="content"></slot>
      <!-- <a href="#" class="btn btn-primary">
        <slot name="btn">如果使用這個的話雖然預設文字可以不出現，但button痕跡會在(待處理)</slot>
      </a> -->
    </div>
  </div>
<!-- 使用方法
<Title :pic="titleBackground">
  <h1 slot="title">This is a big title.</h1>
  <h2 slot="subtitle">This is a big title2.</h2>
  <h3 slot="content">welcome</h3>
  <template slot="btn">button</template>
</Title> -->
</template>

<script>

export default {
  props: {
    pic: {
      type: Object,
      default: () => ({
        url: 'https://picsum.photos/600/300?random=1',
        fixed: false,
      }),
      // 如果有其他資訊要傳如 :pic="titleBackground" 使用方法如下
      // titleBackground: {
      //   url: 'https://picsum.photos/600/300?random=31',
      //   fixed: true,
      // },
    },
  },
  data() {
    return {
      background: this.pic,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.onlytitle {
  background-repeat: no-repeat;
  background-size: cover;
  .txt {
    padding: 30px 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    h1 {
      font-size: 3rem;
      margin: 20px;
    }
    h2 {
      font-size: 2rem;
      margin: 20px;
    }
  }
}
.fixed{
  background-attachment: fixed;
}
@media screen and (max-width: 800px){
  .onlytitle .txt{
    h1{
      font-size: 2rem;
    }
    h2{
      font-size: 1.5rem;
    }
    h3{
      font-size: 1.5rem;
    }
  }
}
</style>
